import { PerformanceTrackingConfig } from './AppPerformanceContext.types';

// We should be alerted if the tracking endpoint is called more than 15 times every 10s
export const DefaultEndpointTrackingConfig: PerformanceTrackingConfig = {
  cooldownMs: 60_000,
  windowMs: 10_000,
  threshold: 15,
};
// We should be alerted if the tracking component is rendered more than 30 times every 10s
export const DefaultComponentTrackingConfig: PerformanceTrackingConfig = {
  cooldownMs: 60_000,
  windowMs: 10_000,
  threshold: 30,
};
